<template>
    <div
        :class="{
            'l-header__search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <AutocompleteForm
                :autocompleteUrl="autocompleteUrl"
                :isFormVisible="isFormVisible"
                :isOpen="isOpen"
                :inputPlaceholder="inputPlaceholder"
                v-model="keyword"
                @show-form="showForm"
                @hide-form="hideForm"
                @searched="setMatches"
            />

            <AutocompleteResults
                v-if="isOpen"
                :matches="matches"
                :keyword="keyword"
                :totals="totals"
            />
        </div>
    </div>
</template>

<script>
import { checkResolution } from 'Functions/helpers';
import RshopAutocomplete from "FrontendComponents/Autocomplete";
import { showHeaderOverlay, hideHeaderOverlay } from 'Functions/overlay';
import AutocompleteForm from 'VueComponents/AutocompleteForm';

export default {
    extends: RshopAutocomplete,
    components: {
        AutocompleteForm: AutocompleteForm,
        AutocompleteResults: () => import("./AutocompleteResults"),
    },
    created() {
        if (typeof Event.on === 'function') {
            Event.on('Autocomplete.showForm', (response) => {
                if (this.isFormVisible) {
                    this.hideForm();
                }
                else {
                    this.showForm();
                }
            });
        }
    },
    data() {
        return {
            isFormVisible: false,
            inputPlaceholder: checkResolution('cxs') ? this.$t('Autocomplete.Header.placeholderMobile') : this.$t('Autocomplete.Header.placeholder'),
        };
    },
    methods: {
        showForm() {
            this.isFormVisible = true

            if (this.matches.count) {
                this.isOpen = true;
            }

            showHeaderOverlay('autocomplete')
        },
        hideForm() {
            this.isFormVisible = false

            hideHeaderOverlay('autocomplete')
        },
        handleClickOutside($event) {
            const isTrigger = $event.target.classList.contains('js-trigger-search') || $event.target.closest('.js-trigger-search');

            if (!this.$el.contains($event.target) && (this.isOpen || this.isFormVisible) && !isTrigger) {
                this.isOpen = false;
                this.hideForm()
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.Event.dispatch === 'function') {
                    window.Event.dispatch("Autocomplete.hide");
                }
            }
        },
    }
};
</script>
